import { Group, lighten, Badge as MantineBadge, Tooltip } from "@mantine/core"
import React from "react"

type Props = {
  value: number
  color: string
  variant?: string
}

export function StatusBadge({ value, color, variant = "filled" }: Props) {
  if (value <= 0) return null

  return (
    <MantineBadge color={color} variant={variant}>
      {value}
    </MantineBadge>
  )
}

type BadgeProps = {
  text: string
  color: string
  icon: React.ReactNode
  tooltipLabel?: string
  isShort?: boolean
}

export function Badge({
  text,
  icon,
  color,
  tooltipLabel,
  isShort = false,
}: BadgeProps) {
  const badge = (
    <MantineBadge
      color={color}
      leftSection={isShort ? null : icon}
      w="max-content"
      size="md"
      fz="10px"
      bd={`1px solid ${lighten(color, 0.2)}`}
    >
      <Group justify="start">{isShort ? icon : text}</Group>
    </MantineBadge>
  )
  return isShort || tooltipLabel ? (
    <Tooltip label={tooltipLabel || text}>{badge}</Tooltip>
  ) : (
    badge
  )
}
